import { takeEvery, call, fork, put, takeLatest } from 'redux-saga/effects';
import { GET_AIRPORT, GET_REGION, SET_ARRIVAL, SET_DEPARTURE, getAirportSucess, getAirportFail, missingToken, getRegionSucess, getRegionFail, findItineraries } from '../actions';
import { getAirport, getUrlParameter, getRegion} from '../api';

function* handlerSetArrival(action) {
    const { from, to, airportNameCode, filters } = action.payload;

    if(from) {
        yield put(findItineraries(airportNameCode[from], airportNameCode[to], filters));
    }
}

function* watchSetArrivalRequest(){
    yield takeLatest(SET_ARRIVAL, handlerSetArrival);
}

function* handlerSetDeparture(action){
    const { from, to, airportNameCode, filters } = action.payload;
    if(to) {
        yield put(findItineraries(airportNameCode[from], airportNameCode[to], filters));
    }
}

function* watchSetDepartureRequest(){
    yield takeLatest(SET_DEPARTURE, handlerSetDeparture);
}

function* handlerGetRegion() {
    const token = getUrlParameter('token');

    if (token === '') {
        yield put(missingToken());
    }

    try {
        const res = yield call(getRegion, token);
        if (res.data.error_msg) {
            yield put(getRegionFail(res.data.error_msg));
        } else {
            yield put(getRegionSucess(res.data));
        }
    } catch(e) {
        yield put(getRegionFail('An error occurred when trying to get region'));
    }
}

function* watchGetRegionRequest() {
    yield takeEvery(GET_REGION, handlerGetRegion);
}

function* handlerGetAirport() {
    const token = getUrlParameter('token');

    if (token === '') {
        yield put(missingToken());
    }

    try {
        const res = yield call(getAirport, token);
        if(res.data.error_msg) {
            yield put(getAirportFail(res.data.error_msg));
        } else {
            yield put(getAirportSucess(res.data));
        }
    }catch(e) {
        yield put(getAirportFail('An error occurred when trying to get airport'));
    }
}

function* watchGetAirportRequest() {
    yield takeEvery(GET_AIRPORT, handlerGetAirport);
}

const mapSagas = [
    fork(watchGetAirportRequest),
    fork(watchGetRegionRequest),
    fork(watchSetArrivalRequest),
    fork(watchSetDepartureRequest)
];

export default mapSagas;